<template>
  <footer class="footer-section">
    <div class="container">
      <div class="footer-left-pic">
        <img src="../assets/img/footer-left-pic.png" alt />
      </div>
      <div class="footer-right-pic">
        <img src="../assets/img/footer-right-pic.png" alt />
      </div>
      <div>
        <router-link class="footer-logo" to="/">
          <img src="../assets/img/cies-logo-white.svg" width="100" alt />
        </router-link>
        <p class="text-white pt-2">Copa IFCE de e-sports</p>
      </div>

      <!-- <div class="pt-5"></div> -->
      <!-- <ul class="main-menu footer-menu">
        <li>
          <a href>Home</a>
        </li>
        <li>
          <a href>Games</a>
        </li>
        <li>
          <a href>Reviews</a>
        </li>
        <li>
          <a href>News</a>
        </li>
        <li>
          <a href>Contact</a>
        </li>
      </ul>-->
      <div class="footer-social d-flex justify-content-center">
        <a href="https://www.facebook.com/ciesoficial/">
          <i class="fa fa-facebook fa-2x"></i>
        </a>
        <a href="https://www.instagram.com/ciesoficial">
          <i class="fa fa-instagram fa-2x"></i>
        </a>
        <a href="https://www.twitch.tv/ciesoficial">
          <i class="fa fa-twitch fa-2x"></i>
        </a>
      </div>
      <div class="copyright">
        <a href>Colorlib</a> 2018 @ All rights reserved
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>
